// Smart due-date / age display logic for the task row.
//
// Returns { text, severity } where severity drives the text color in the
// chip:
//   overdue → red, today → amber, soon → amber, normal → muted gray,
//   stale   → muted gray italic.

const MS_PER_DAY = 1000 * 60 * 60 * 24

function startOfDay(date) {
  const d = new Date(date)
  d.setHours(0, 0, 0, 0)
  return d
}

function diffDays(later, earlier) {
  return Math.floor((startOfDay(later) - startOfDay(earlier)) / MS_PER_DAY)
}

function parseISODate(value) {
  // Treat YYYY-MM-DD as a calendar date in the local timezone, not UTC,
  // so "due in 0 days" means "the user's today".
  const [y, m, d] = value.split('-').map(Number)
  return new Date(y, (m ?? 1) - 1, d ?? 1)
}

export function dueAgeText(task, now = new Date()) {
  if (task.dueDate) {
    const due = parseISODate(task.dueDate)
    const diff = diffDays(due, now)
    if (diff < 0) {
      return { text: `Overdue ${Math.abs(diff)}d`, severity: 'overdue' }
    }
    if (diff === 0) return { text: 'Due today', severity: 'today' }
    if (diff <= 3) return { text: `Due in ${diff}d`, severity: 'soon' }
    return { text: `Due in ${diff}d`, severity: 'normal' }
  }
  if (!task.createdAt) return { text: '', severity: 'normal' }
  const created = new Date(task.createdAt)
  const diffD = diffDays(now, created)
  if (diffD <= 0) return { text: 'Created today', severity: 'normal' }
  if (diffD < 7) return { text: `Created ${diffD}d ago`, severity: 'normal' }
  if (diffD < 30) {
    return { text: `Created ${Math.floor(diffD / 7)}w ago`, severity: 'normal' }
  }
  return {
    text: `Created ${Math.floor(diffD / 30)}mo ago`,
    severity: 'stale',
  }
}
